export const SKELETON_PRODUCT_TYPES_PREVIEW_COUNT = 8;
export const SKELETON_PRODUCT_ITEMS_PREVIEW_COUNT = 8;
export const SHARED_CATALOG_PREVIEW_LIMIT = 15;
export const SHARED_CATALOG_ITEMS_PREVIEW_LIMIT = 30;
